import { Component, HostListener, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../environments/environment';
import { NavigationStart, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { AppService } from './app.service';
import { DomEventService } from './common/dom-event/dom-event.service';
import { CookieService } from "ngx-cookie-service";

export let browserRefresh = false;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy{

  subscription: Subscription;
  maintenanceStartTime : any = environment.maintenanceStartTime;
  maintenanceEndTime : any = environment.maintenanceEndTime;
  currentTime : any = this.appService.formatcreatedDateUTC(new Date());
  displayMainetance : boolean = false;
  userActivity;
  userInactive: Subject<any> = new Subject();

  lockActivity;
  unlockActivity: Subject<any> = new Subject();

  constructor(private router: Router, private appService: AppService, private domEventService:DomEventService,
    public cookieService: CookieService) {
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
      }
    });

    this.setTimeout();

    //Cp-3234 -start
    this.unlockActivity.subscribe(() => {
      sessionStorage.setItem("UserIdle5", 'true');
      let customerCode = localStorage.getItem("customerCode")
      let businessObjectIds = JSON.parse(sessionStorage.getItem("businnessObjIds"));
      let userName = localStorage.getItem('userName');
      let url = localStorage.getItem("defaultHomepage");
      if (customerCode === "COX" && businessObjectIds) {
        this.appService.releaseLockedOrders(businessObjectIds, customerCode, userName, url);
      }
    });//cp-3234 -end

    this.userInactive.subscribe(() => {
      sessionStorage.setItem("UserIdle10", 'true');
      //this.isUserIdle = true;
    });

    window.onbeforeunload =() =>{ //Cp-3234
      let customerCode = localStorage.getItem("customerCode")
      let businessObjectIds = JSON.parse(sessionStorage.getItem("businnessObjIds"));
      let userName = localStorage.getItem('userName');
      let url = localStorage.getItem("defaultHomepage");
      if (customerCode === "COX" && businessObjectIds) {
        this.appService.releaseLockedOrders(businessObjectIds, customerCode, userName, url);
      }
    }
  }

  setTimeout() {
    this.lockActivity = setTimeout(() => {//Cp-3234
      this.unlockActivity.next(undefined)
    }, 5 * 60 * 1000);

    this.userActivity = setTimeout(() => {
      this.userInactive.next(undefined)
    }, 10 * 60 * 1000);
  }

  @HostListener('window:mousemove') refreshUserState1() {
    sessionStorage.setItem("UserIdle5", 'false');
    sessionStorage.setItem("UserIdle10", 'false');
    clearTimeout(this.lockActivity);
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('window:keypress') refreshUserState2() {
    sessionStorage.setItem("UserIdle5", 'false');
    sessionStorage.setItem("UserIdle10", 'false');
    clearTimeout(this.lockActivity);
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  /*@HostListener('window:beforeunload') beforeunloadHandler() {//Cp-3234
    //this.unlockActivity.next(undefined);
    let customerCode = localStorage.getItem("customerCode")
    let businessObjectIds = JSON.parse(sessionStorage.getItem("businnessObjIds"));
    let userName = localStorage.getItem('userName');
    let url = localStorage.getItem("defaultHomepage");
    if (customerCode === "COX") {
      this.appService.releaseLockedOrders(businessObjectIds, customerCode, userName, url);
    }
  }*/

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  drawerOpen = true;

  toggleDrawer(event: Event) {
    this.drawerOpen = !this.drawerOpen;
  }

  ngOnInit() {
    console.log("CurrentT::::",this.currentTime);
    console.log("Start::::",this.maintenanceStartTime);
    console.log("Start::::",this.maintenanceEndTime);
    if(this.currentTime >= this.maintenanceStartTime && this.currentTime <= this.maintenanceEndTime)
    {
      this.displayMainetance = true;
      environment.isSingleSignOn = false;
    }
    sessionStorage.setItem("UserIdle10", 'false');
    if(environment.isSingleSignOn){
      if(this.cookieService.get('id_token') === null || this.cookieService.get('id_token') === undefined || this.cookieService.get('id_token') === ''){
        /*let timestamp = +new Date();
        let clientId= 'ecb686e4-516d-4f15-befe-d64b1ec94446';
        let url = 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e/oauth2/authorize?response_type=id_token code&client_id='
          + clientId
          + '&redirect_uri=' + window.location.origin + '/login'
          + '&nonce=' + timestamp;
          window.location.href = url;
        */
      } 
      else { //cp-3498 -start
        let tokenExpiryTime = parseInt(localStorage.getItem('tokenExpiryTime'));
        // let tokenExpiresIn = (tokenExpiryTime - (5 * 60)) * 1000;

        let tokenExpiry = new Date(tokenExpiryTime*1000);
        let currentLocalTime = new Date();
        
        let expiresIn = (tokenExpiry.getTime() - currentLocalTime.getTime());
        expiresIn = expiresIn - (6 * 60 * 1000);//in milliseconds

        if (expiresIn && expiresIn > 0 && this.appService.refreshCalled == false) {
          this.appService.refreshCalled = true;
          this.appService.refreshToken(expiresIn);
        }
      }//cp-3498 -end
    }
  }

  // constructor() {
  //   if(environment.isSingleSignOn){
  //     this.adal.init(this.adalConfiguration);
  //   }
  // }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    this.domEventService.click.next(event);
  }

  @HostListener("document:keydown", ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    this.domEventService.keyDown.next(event);
  }

  @HostListener("document:keyup", ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    this.domEventService.keyUp.next(event);
  }

  @HostListener("document:keyup.Tab", ['$event'])
  onKeyTab(event: KeyboardEvent): void {
    this.domEventService.keyUpTab.next(event);
  }
}
